// extracted by mini-css-extract-plugin
export var icon = "_8a-3";
export var subtitle = "_8a-2";
export var title = "_8a-1";
export var value = "_8a-0";